import axios from "axios";
import { useEffect, useState } from "react";
import { FaArrowLeft, FaTrash, FaUserEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../api";
import { ITeamMembership } from "../api/services/team.service";
import { IUserResponse } from "../api/services/user.service";
import MemberDialog from "./dialogs/MemberDialog";

export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export function ActionBar({
  teamId,
}: // trackUpdateLoading,
{
  teamId: string | undefined;
}) {
  let navigate = useNavigate();
  const [isModalOpenMember, setIsModalOpenMember] = useState(false);
  const [members, setMembers] = useState<ITeamMembership[]>([]);
  const [users, setUsers] = useState<IUserResponse[]>([]);

  useEffect(() => {
    if (isModalOpenMember) {
      getMembers();
      getUsers();
    }
  }, [isModalOpenMember]);

  async function getMembers() {
    try {
      // setLoading(true);
      if (teamId) {
        const { data } = await api.team.getTeamMembers(teamId);
        if (data.result) {
          setMembers(data.result);
          console.log(data.result);
          // setLoading(false);
        }
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error(
          "Something really went wrong, you might want to contact support!"
        );
      }
    }
  }

  async function getUsers() {
    try {
      // setLoading(true);
      if (teamId) {
        const { data } = await api.user.getUsers();
        if (data.result) {
          setUsers(data.result);
          console.log(data.result);
          // setLoading(false);
        }
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error(
          "Something really went wrong, you might want to contact support!"
        );
      }
    }
  }

  async function addMember(userId: string, teamRole: string) {
    try {
      if (teamId) {
        const { data } = await api.team.addMember(teamId, {
          userId,
          role: teamRole || "GUEST",
          teamId,
        });
        if (data.result) {
          getMembers();
          console.log(data.result);
        }
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error(
          "Something really went wrong, you might want to contact support!"
        );
      }
    }
  }

  async function removeMember(userId: string) {
    try {
      if (teamId) {
        const { data } = await api.team.removeMember(teamId, userId);
        // if (data.result) {
        getMembers();
        getUsers();
        // console.log(data.result);
        // }
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error(
          "Something really went wrong, you might want to contact support!"
        );
      }
    }
  }

  async function deleteTeam() {
    try {
      if (teamId) {
        const { data } = await api.team.deleteTeam(teamId);
        toast.success("Team deleted");
        navigate("/");
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error(
          "Something really went wrong, you might want to contact support!"
        );
      }
    }
  }

  return (
    <div className="flex flex-row justify-between w-full">
      <MemberDialog
        isOpen={isModalOpenMember}
        setIsOpen={setIsModalOpenMember}
        members={members}
        fetchMembers={getMembers}
        addMember={addMember}
        removeMember={removeMember}
        users={users}
      />
      <button
        className="bg-indigo-600 text-white rounded px-4 py-1 hover:bg-indigo-800 font-semibold flex items-center space-x-2"
        onClick={() => navigate("/")}
      >
        <FaArrowLeft />
        <div>Back</div>
      </button>
      <div className="flex items-center space-x-4">
        <div className="flex justify-end space-x-4">
          <button
            onClick={() => setIsModalOpenMember(true)}
            className="bg-emerald-600 text-white rounded px-4 py-1 hover:bg-emerald-800 font-semibold flex items-center space-x-2 disabled:bg-slate-300 dark:disabled:bg-slate-600 disabled:text-slate-200 dark:disabled:text-slate-700"
          >
            <div>Edit members</div>
            <FaUserEdit />
          </button>
          <button
            className="bg-rose-600 text-white rounded px-4 py-1 hover:bg-rose-800 font-semibold flex items-center space-x-2 disabled:bg-slate-300 dark:disabled:bg-slate-600 disabled:text-slate-200 dark:disabled:text-slate-700"
            onClick={deleteTeam}
          >
            <FaTrash aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}
